@if (showNavigation()) {
  <gandalf-header></gandalf-header>
}
<router-outlet/>
